import { ENDPOINTS, getFullUrl } from "../config";

export class AdminDriverService {
  static getToken(): string | null {
    return localStorage.getItem("token");
  }
  static getRole(): string | null {
    return localStorage.getItem("auth_user");
  }

  static async getDriverListing(
    page = 1,
    pageSize = 10,
    filters: {
      type?: "driver" | "pickup";
    }
  ): Promise<{
    success: boolean;
    message?: string;
    data?: {
      pagination: {
        totalItems: number;
        totalPages: number;
        page: number;
      };
    };
  }> {
    try {
      const filtersObj: Record<string, any> = {};
      if (filters.type) {
        filtersObj.type = filters.type;
      }

      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        filters: JSON.stringify(filtersObj),
      });

      const url = `${getFullUrl(
        ENDPOINTS.DRIVER.GETDRIVERLISTING
      )}?${params.toString()}`;

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch orders:", error);
      throw error;
    }
  }
}
